module.exports = __webpack_public_path__ + "static/media/tanar.85095883.png";